import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminTradeInstanceRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/instances/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/admin/TradesInstances/AdminTradeInstancePage/AdminTradeInstancePage').then(
    (d) => d.Route
  )
);
